/**
 * An enumeration of HTTP content types.
 */
export default {
    JSON: "application/json",
    FORM: "application/x-www-form-urlencoded"
};